import "./styles.scss";

import classnames from "classnames";

import { ReactComponent as CheckmarkIcon } from "assets/icons/radio-checkmark.svg";

const mainClass = "radio-button";

const RadioButton = ({
  label,
  type = "radio",
  name,
  input_value,
  checked,
  disabled,
  onHintClick,
  onClick,
}) => {
  return (
    <div
      className={classnames(mainClass, {
        [`${mainClass}--active`]: !!checked,
      })}
    >
      <label>
        <span>{label}</span>
        <input
          type={type}
          name={name}
          onClick={onClick}
          checked={checked}
          value={input_value}
          disabled={disabled}
        />
        <i>
          <CheckmarkIcon />
        </i>
      </label>
      {onHintClick && (
        <button
          className={`${mainClass}__hint`}
          type="button"
          onClick={onHintClick}
        >
          ?
        </button>
      )}
    </div>
  );
};

export default RadioButton;
